function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1988(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 25.09,
    height: 13.04,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.8628571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.545,
    y: 6.52
  }, "\n        Tyrrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 13.04,
    width: 25.09,
    height: 20.58,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.4299999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.545,
    y: 23.33
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 33.62,
    width: 25.09,
    height: 20.71,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.1775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.545,
    y: 43.974999999999994
  }, "\n        Hyde\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 54.33,
    width: 25.09,
    height: 30.56,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.509
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.545,
    y: 69.61
  }, "\n        Perquimans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 84.89,
    width: 25.09,
    height: 31.28,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.181666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.545,
    y: 100.53
  }, "\n        Graham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 116.17,
    width: 25.09,
    height: 31.84,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.2725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.545,
    y: 132.09
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 148.02,
    width: 25.09,
    height: 31.89,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.018
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.545,
    y: 163.965
  }, "\n        Gates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 179.9,
    width: 25.09,
    height: 32.96,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.018
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.545,
    y: 196.38
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 212.86,
    width: 25.09,
    height: 33.17,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.018
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.545,
    y: 229.44500000000002
  }, "\n        Swain\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 246.03,
    width: 25.09,
    height: 33.43,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.181666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.545,
    y: 262.745
  }, "\n        Chowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 279.46,
    width: 25.09,
    height: 36.65,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.787777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.545,
    y: 297.78499999999997
  }, "\n        Currituck\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 316.11,
    width: 25.09,
    height: 39.01,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.787777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.545,
    y: 335.615
  }, "\n        Alleghany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 355.13,
    width: 25.09,
    height: 41.23,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.584285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.545,
    y: 375.745
  }, "\n        Pamlico\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 396.36,
    width: 25.09,
    height: 45.79,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.509
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.545,
    y: 419.255
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 442.14,
    width: 25.09,
    height: 47.93,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.181666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.545,
    y: 466.10499999999996
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 490.07,
    width: 25.09,
    height: 48.8,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.2725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.545,
    y: 514.47
  }, "\n        Hoke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 538.86,
    width: 25.09,
    height: 51.95,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.018
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.545,
    y: 564.835
  }, "\n        Avery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 590.82,
    width: 25.09,
    height: 54.16,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.181666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.545,
    y: 617.9000000000001
  }, "\n        Bertie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 644.97,
    width: 25.09,
    height: 55.03,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.13625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.545,
    y: 672.485
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.09,
    y: 0,
    width: 36.01,
    height: 40.95,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.0025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.095,
    y: 20.475
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.1,
    y: 0,
    width: 36.04,
    height: 40.95,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.006666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.12,
    y: 20.475
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 97.14,
    y: 0,
    width: 36.47,
    height: 40.95,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.21
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 115.375,
    y: 20.475
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 133.62,
    y: 0,
    width: 37.88,
    height: 40.95,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.3133333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 152.56,
    y: 20.475
  }, "\n        Martin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.5,
    y: 0,
    width: 39.43,
    height: 40.95,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5845454545454545
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 191.215,
    y: 20.475
  }, "\n        Northampton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 210.92,
    y: 0,
    width: 39.72,
    height: 40.95,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.965
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 230.77999999999997,
    y: 20.475
  }, "\n        Scotland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 250.64,
    y: 0,
    width: 40.06,
    height: 40.95,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.0075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 270.66999999999996,
    y: 20.475
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 290.7,
    y: 0,
    width: 42.1,
    height: 40.95,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.8500000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 311.75,
    y: 20.475
  }, "\n        Caswell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 332.8,
    y: 0,
    width: 42.79,
    height: 40.95,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.190000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 354.195,
    y: 20.475
  }, "\n        Anson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 375.59,
    y: 0,
    width: 44.25,
    height: 40.95,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.095000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 397.715,
    y: 20.475
  }, "\n        Pasquotank\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 419.83,
    y: 0,
    width: 44.46,
    height: 40.95,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.11875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 442.06,
    y: 20.475
  }, "\n        Hertford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 464.29,
    y: 0,
    width: 44.85,
    height: 40.95,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 486.71500000000003,
    y: 20.475
  }, "\n        Yancey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 509.14,
    y: 0,
    width: 45.25,
    height: 40.95,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.2375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 531.765,
    y: 20.475
  }, "\n        Dare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 554.39,
    y: 0,
    width: 47.82,
    height: 40.95,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.095000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 578.3,
    y: 20.475
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 602.21,
    y: 0,
    width: 48.37,
    height: 40.95,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 626.395,
    y: 20.475
  }, "\n        Person\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 650.59,
    y: 0,
    width: 49.41,
    height: 40.95,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 675.2950000000001,
    y: 20.475
  }, "\n        Bladen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.09,
    y: 40.95,
    width: 48.69,
    height: 43.96,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.326666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.435,
    y: 62.93000000000001
  }, "\n        Pender\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.09,
    y: 84.91,
    width: 48.69,
    height: 46.28,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.256
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.435,
    y: 108.05
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.09,
    y: 131.19,
    width: 48.69,
    height: 47.54,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.885
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.435,
    y: 154.96
  }, "\n        Ashe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.09,
    y: 178.74,
    width: 48.69,
    height: 47.73,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.8185714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.435,
    y: 202.60500000000002
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.09,
    y: 226.47,
    width: 48.69,
    height: 49.22,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.41
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.435,
    y: 251.07999999999998
  }, "\n        Granville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.09,
    y: 275.69,
    width: 48.69,
    height: 51.68,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.08625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.435,
    y: 301.53
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.09,
    y: 327.37,
    width: 48.69,
    height: 51.85,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.08625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.435,
    y: 353.295
  }, "\n        McDowell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.09,
    y: 379.22,
    width: 48.69,
    height: 52.51,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.115
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.435,
    y: 405.475
  }, "\n        Yadkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.09,
    y: 431.73,
    width: 48.69,
    height: 52.77,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.738
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.435,
    y: 458.115
  }, "\n        Davie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.09,
    y: 484.5,
    width: 48.69,
    height: 53.17,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.738
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.435,
    y: 511.085
  }, "\n        Vance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.09,
    y: 537.67,
    width: 48.69,
    height: 53.42,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.0575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.435,
    y: 564.38
  }, "\n        Transylvania\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.09,
    y: 591.09,
    width: 48.69,
    height: 53.62,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.23
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.435,
    y: 617.9
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.09,
    y: 644.71,
    width: 48.69,
    height: 55.29,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.115
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.435,
    y: 672.355
  }, "\n        Duplin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.78,
    y: 40.95,
    width: 46.69,
    height: 59.76,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.187777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 97.125,
    y: 70.83
  }, "\n        Alexander\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120.47,
    y: 40.95,
    width: 47.09,
    height: 59.76,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.88625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 144.015,
    y: 70.83
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 167.56,
    y: 40.95,
    width: 52.13,
    height: 59.76,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.51625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 193.625,
    y: 70.83
  }, "\n        Beaufort\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 219.69,
    y: 40.95,
    width: 53.83,
    height: 59.76,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.971666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 246.605,
    y: 70.83
  }, "\n        Stokes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 273.52,
    y: 40.95,
    width: 56.24,
    height: 59.76,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.034285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 301.64,
    y: 70.83
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 329.75,
    y: 40.95,
    width: 56.8,
    height: 59.76,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.114285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 358.15,
    y: 70.83
  }, "\n        Watauga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 386.55,
    y: 40.95,
    width: 61.01,
    height: 59.76,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.47
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 417.055,
    y: 70.83
  }, "\n        Columbus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 447.56,
    y: 40.95,
    width: 61.14,
    height: 59.76,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.64
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 478.13,
    y: 70.83
  }, "\n        Edgecombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 508.71,
    y: 40.95,
    width: 62.28,
    height: 59.76,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.537142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 539.85,
    y: 70.83
  }, "\n        Halifax\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 570.98,
    y: 40.95,
    width: 63.6,
    height: 59.76,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.537142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 602.78,
    y: 70.83
  }, "\n        Sampson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 634.58,
    y: 40.95,
    width: 65.42,
    height: 59.76,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.537142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 667.2900000000001,
    y: 70.83
  }, "\n        Harnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.78,
    y: 100.71,
    width: 62.9,
    height: 63.16,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.29
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.23,
    y: 132.29
  }, "\n        Rutherford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.78,
    y: 163.87,
    width: 62.9,
    height: 65.47,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.988888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.23,
    y: 196.60500000000002
  }, "\n        Brunswick\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.78,
    y: 229.35,
    width: 62.9,
    height: 65.67,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.8625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.23,
    y: 262.185
  }, "\n        Carteret\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.78,
    y: 295.02,
    width: 62.9,
    height: 65.8,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.985714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.23,
    y: 327.91999999999996
  }, "\n        Haywood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.78,
    y: 360.82,
    width: 62.9,
    height: 66.17,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.985714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.23,
    y: 393.905
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.78,
    y: 426.99,
    width: 62.9,
    height: 66.98,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.483333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.23,
    y: 460.48
  }, "\n        Lenoir\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.78,
    y: 493.97,
    width: 62.9,
    height: 67.64,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.483333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.23,
    y: 527.7900000000001
  }, "\n        Stanly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.78,
    y: 561.61,
    width: 62.9,
    height: 68.1,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.58
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.23,
    y: 595.66
  }, "\n        Surry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.78,
    y: 629.72,
    width: 62.9,
    height: 70.28,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.483333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.23,
    y: 664.86
  }, "\n        Wilson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136.68,
    y: 100.71,
    width: 60.79,
    height: 73.33,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.131666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 167.07500000000002,
    y: 137.375
  }, "\n        Craven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 197.47,
    y: 100.71,
    width: 61.01,
    height: 73.33,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.168333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 227.975,
    y: 137.375
  }, "\n        Onslow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 258.48,
    y: 100.71,
    width: 69.65,
    height: 73.33,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.930000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 293.305,
    y: 137.375
  }, "\n        Moore\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 328.13,
    y: 100.71,
    width: 70.48,
    height: 73.33,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.746666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 363.37,
    y: 137.375
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 398.61,
    y: 100.71,
    width: 72.23,
    height: 73.33,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.02875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 434.725,
    y: 137.375
  }, "\n        Caldwell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 470.84,
    y: 100.71,
    width: 76.16,
    height: 73.33,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.16625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 508.91999999999996,
    y: 137.375
  }, "\n        Johnston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 547,
    y: 100.71,
    width: 76.38,
    height: 73.33,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.147777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 585.19,
    y: 137.375
  }, "\n        Cleveland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 623.38,
    y: 100.71,
    width: 76.62,
    height: 73.33,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 661.69,
    y: 137.375
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136.68,
    y: 174.05,
    width: 83.75,
    height: 67.77,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.9425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.555,
    y: 207.935
  }, "\n        Nash\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136.68,
    y: 241.82,
    width: 83.75,
    height: 70.99,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.197999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.555,
    y: 277.315
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136.68,
    y: 312.81,
    width: 83.75,
    height: 71.72,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.172
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.555,
    y: 348.67
  }, "\n        Rockingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136.68,
    y: 384.53,
    width: 83.75,
    height: 73.52,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.703999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.555,
    y: 421.28999999999996
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136.68,
    y: 458.05,
    width: 83.75,
    height: 74.02,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.574285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.555,
    y: 495.06
  }, "\n        Robeson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136.68,
    y: 532.07,
    width: 83.75,
    height: 79.84,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.871111111111112
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.555,
    y: 571.99
  }, "\n        Henderson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136.68,
    y: 611.91,
    width: 83.75,
    height: 88.09,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.964285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.555,
    y: 655.9549999999999
  }, "\n        Iredell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 220.43,
    y: 174.05,
    width: 91.23,
    height: 81.96,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.245
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 266.045,
    y: 215.03
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 311.66,
    y: 174.05,
    width: 92.79,
    height: 81.96,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.49
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 358.055,
    y: 215.03
  }, "\n        Pitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 404.45,
    y: 174.05,
    width: 93.13,
    height: 81.96,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.245
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 451.015,
    y: 215.03
  }, "\n        Cabarrus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 497.58,
    y: 174.05,
    width: 99.2,
    height: 81.96,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.392
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 547.18,
    y: 215.03
  }, "\n        Rowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 596.78,
    y: 174.05,
    width: 103.22,
    height: 81.96,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.245
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 648.39,
    y: 215.03
  }, "\n        Alamance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 220.43,
    y: 256.01,
    width: 108.24,
    height: 78.62,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.103333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 274.55,
    y: 295.32
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 220.43,
    y: 334.63,
    width: 108.24,
    height: 83.38,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.579999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 274.55,
    y: 376.32
  }, "\n        New_Hanover\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 220.43,
    y: 418.01,
    width: 108.24,
    height: 88.37,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.04625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 274.55,
    y: 462.195
  }, "\n        Davidson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 220.43,
    y: 506.38,
    width: 108.24,
    height: 88.74,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.677142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 274.55,
    y: 550.75
  }, "\n        Catawba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 220.43,
    y: 595.11,
    width: 108.24,
    height: 104.89,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.481666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 274.55,
    y: 647.5550000000001
  }, "\n        Gaston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 328.67,
    y: 256.01,
    width: 104.67,
    height: 111.82,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.467
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 381.005,
    y: 311.91999999999996
  }, "\n        Cumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 433.34,
    y: 256.01,
    width: 131.39,
    height: 111.82,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.9775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 499.03499999999997,
    y: 311.91999999999996
  }, "\n        Buncombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 564.73,
    y: 256.01,
    width: 135.27,
    height: 111.82,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.636666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 632.365,
    y: 311.91999999999996
  }, "\n        Durham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 328.67,
    y: 367.82,
    width: 148.57,
    height: 151.02,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 21.224285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 402.95500000000004,
    y: 443.33
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 328.67,
    y: 518.85,
    width: 148.57,
    height: 181.15,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.57125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 402.95500000000004,
    y: 609.4250000000001
  }, "\n        Guilford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 477.25,
    y: 367.82,
    width: 222.75,
    height: 147.9,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 36.975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 588.625,
    y: 441.77
  }, "\n        Wake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 477.25,
    y: 515.73,
    width: 222.75,
    height: 184.27,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.751818181818184
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 588.625,
    y: 607.865
  }, "\n        Mecklenburg\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1988);
export default __webpack_public_path__ + "static/media/1988.7c542c5d55a9b1286e3ddbed7162123a.svg";
export { ForwardRef as ReactComponent };